export default function translate(obj: string) {
    if (!obj) return
    if (getLegislation() === 'lesgilationBase') return getStringFromObject(obj.split('.'), legislationBase)
}

function getLegislation() {
    return 'lesgilationBase'
}

function getStringFromObject(textArray: string[], legislation: any) {
    textArray.forEach((text: string, i: number) => {
        if (typeof legislation === 'string') return
        legislation = legislation[textArray[i]]
    })
    if (!legislation || typeof legislation !== 'string') return textArray.join('.')
    return legislation
}


export const legislationBase = {
    "rolesModal": {
        "screen": "Screen",
        "accessLevel": "Access Level"
    },
    "permissionObject": {
        "all": "All",
        "users": "Accounts",
        "bingo_config":"Bingo Configuration",
        "bingo_games":"Bingo Games",
        "bingo_jackpots":"Bingo Jackpot",
        "bingo_jackpot_history":"Bingo Jackpot History",
        "bundle_management": "Bundle Management",
        "cashiers": "Cashiers",
        "charities": "Charities",
        "boxes": "Decks",
        "decks_management": "Decks Management",
        "decks_status": "Decks Status",
        "devices": "Devices",
        "devices_push_command": "Devices Push Command",
        "device_versions": "Device Version Management",
        "device_bulk_edit": "Device Bulk Edit",
        "distributors": "Distributors",
        "drawer_management": "Drawer Management",
        "games": "Games",
        "bingo_jackpot_payrolls":"Jackpot Payments",
        "game_orderings": "Lobby Order",
        "lobby_tabs": "Lobby Tabs",
        "locations": "Locations",
        "location_close": "Close Locations",
        "config": "Portal Config",
        "pos_bundle_server_management": "POS Bundle Server Management",
        "roles": "Roles",
        "logs": "System Logs",
        "tournament_server_access": "Tournament Server Access",
        "report_bingo_account":"Bingo Account Report",
        "report_bingo_active_progressives":"Bingo Active Progressives Report",
        "report_bingo_active_sites":"Bingo Active Sites Report",
        "report_bingo_charities_progressive":"Bingo Charities Progressives Contribution Report",
        "report_bingo_charity_monthly_invoice":"Bingo Charity Invoice Report",
        "report_bingo_distributor_monthly_statement":"Bingo Distributor Statement Report",
        "report_bingo_game_log":"Bingo Game Log Report",
        "report_bingo_jackpot_winners":"Bingo Jackpot Winners Report",
        "report_bingo_lbp_monthly":"Bingo LBP Monthly Report",
        "report_bingo_performance":"Bingo Performance Report",
        "report_bingo_play":"Bingo Play Report",
        "report_bingo_progressive_daily":"Bingo Progressive Contribution Report",
        "report_cashier_activity": "Cashier Activity Report",
        "report_closed_game": "Closed Pull-Tabs Games Report",
        "report_current_inventory": "Current Inventory Report",
        "report_daily_deposit": "Daily Deposit Report",
        "report_daily_deposit_sales": "Daily Deposit - Sales Report",
        "report_daily_revenue": "Daily Sales Detail Report",
        "dashboard": "Dashboard Report",
        "report_deck_status": "Deck Status Report",
        "report_device_utilization": "Device Utilization Report",
        "report_distributor_game": "Distributor Game Report",
        "report_game_definition": "Game Definition Report",
        "report_game_performance": "Game Performance Report", 
        "report_game_performance_with_variants": "Game Performance with Variants Report",
        "report_historical_inventory": "Historical Inventory Report",
        "historical_transaction_log": "Historical Transaction Report",
        "report_cashout_activity": "Large Cashout Activity Report",
        "report_site_inventory": "Location Inventory Report",
        "report_site_list": "Location List Report",
        "report_month_end": "Month End Report",
        "report_monthly_reports": "Monthly Reports",
        "report_period_revenue": "Period Revenue Report",
        "report_pos_bundle_status": "POS Bundle Status Report",
        "rt_location_status": "Real-Time Location Status",
        "rt_transaction_log": "Real-Time Transaction Log",
        "report_weekday_revenue_graph": "Revenue by Day of Week Report",
        "report_revenue_by_device_graph": "Revenue by Device Report", 
        "report_revenue_by_game_graph": "Revenue by Game Report", 
        "report_revenue_by_period_graph": "Revenue by Period Report",
        "report_user_list": "User List Report",
        "messaging": "Messaging Configuration",
    }
}




